import { store } from "../../../../../../../redux/store";
import { updateBodyBuilder, updateBodyStack } from "../../../../../../../redux/actions/DeploymentActions";
import { immutableArraySlice } from "../../../../../../../helpers/common";
import { reorderApps } from "../../../../../custom/_helpers/custom";

export function handleFeaturesSwitch(featuresToSwitch, custom) {

    const {bodyStack, bodyBuilder, featuresData} = store.getState().deployment;
    const {dependencies} = featuresData;
    let selected = {
        integrated_features: bodyStack.integrated_features,
        extended_features: bodyStack.extended_features,
        subscriptions: bodyStack.subscriptions,
    };
    let newForm = bodyStack.form_app;
    let customFeatures = [...bodyBuilder.feature];

    featuresToSwitch.map(feature => {

        const planType = custom ? feature.category[0].name : feature.type;

        if (!selected[planType].find(f => f === feature.code)) {
            let selection = [feature];
            // get required features list
            const required = dependencies.filter(master => master.dependents.some(d => d.code === feature.code));
            required?.map(r => { // add requirement if it wasn't previously enabled
                if (!bodyStack[planType].includes(r.code)) selection.push(r);
            });

            selection.map(f => {
                selected = {
                    ...selected,
                    ...{[planType]: [...selected[planType], ...[f.code]]}
                }

                if (custom && planType !== 'subscriptions') {
                    customFeatures = [
                        ...customFeatures,
                        ...[{
                            ...f,
                            ...(!!f.versions.length ? {version: f.versions[f.versions.length - 1]} : {}),
                        }]]
                    ;
                    customFeatures = reorderApps(customFeatures);
                }
            })
        } else {
            let deselection = [feature];
            // check if feature has dependents to disable them
            const slaves = dependencies.find(d => d.code === feature.code)?.dependents || null;
            slaves?.map(dependent => deselection.push(dependent));

            deselection.map(f => {
                selected = {
                    ...selected,
                    ...{[planType]: immutableArraySlice(f.code, selected[planType])}
                }
                // remove stored app form data as well (some apps require additional user submitted data)
                newForm = immutableArraySlice(f, newForm, 'code');
                if (custom && planType !== 'subscriptions') {
                    customFeatures = immutableArraySlice(f, customFeatures, '_id');
                }
            });
        }
    })

    store.dispatch(updateBodyStack(selected));
    // prevent excessive store updating
    if (newForm !== bodyStack.form_app) store.dispatch(updateBodyStack({form_app: newForm}));
    if (custom) store.dispatch(updateBodyBuilder({feature: customFeatures}));
}